// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalHeader_modalHeader__lj8rn","closeHeader":"ModalHeader_closeHeader__k7QoL"};